export default "__VITE_ASSET__f3a0e2f3__"